import {
  MetricsV1AggregationThresholdInput,
  MetricsV1AggregationType,
  MetricsV1FilterInput,
  MetricsV1ValueCapInput,
} from '@spotify/confidence-graphql';

type AggregationLike = {
  type?: MetricsV1AggregationType | null;
  threshold?: Maybe<MetricsV1AggregationThresholdInput>;
  cap?: Maybe<MetricsV1ValueCapInput>;
};

export type AverageMetricSpec = {
  measurement?: Maybe<{ name?: string | null }>;
  aggregation?: AggregationLike | null;
};

export type RatioMetricSpec = {
  numerator?: Maybe<{ name?: string | null }>;
  denominator?: Maybe<{ name?: string | null }>;
  numeratorAggregation?: AggregationLike | null;
  denominatorAggregation?: AggregationLike | null;
  numeratorFilter?: Maybe<MetricsV1FilterInput>;
};

export type SimplifiedQueryTypeSpec = {
  averageMetricSpec?: Maybe<AverageMetricSpec>;
  ratioMetricSpec?: Maybe<RatioMetricSpec>;
};

export type MeasurementInput = {
  typeSpec?: Maybe<SimplifiedQueryTypeSpec>;
  nullHandling?: Maybe<{ replaceEntityNullWithZero?: boolean | null }>;
  filter?: Maybe<MetricsV1FilterInput>;
};

export type AverageMeasurement = MeasurementInput & {
  typeSpec: SimplifiedQueryTypeSpec & { averageMetricSpec: AverageMetricSpec };
};

export type RatioMeasurement = MeasurementInput & {
  typeSpec: SimplifiedQueryTypeSpec & { ratioMetricSpec: RatioMetricSpec };
};

export const isAverageMeasurement = (
  measurement: MeasurementInput,
): measurement is AverageMeasurement =>
  Boolean(measurement.typeSpec?.averageMetricSpec);

export const isRatioMeasurement = (
  measurement: MeasurementInput,
): measurement is RatioMeasurement =>
  Boolean(measurement.typeSpec?.ratioMetricSpec);
